<script>
export default {
  name: 'ImageListItem',
  props: {
    type: {
      type: String,
      required: false,
      validator(value) {
        return ['accreditation', 'payment', 'supplement-info'].includes(value)
      }
    },
    images: {
      type: Array,
      default() {
        return this.type === 'accreditation'
          ? [
              'cyber-essentials-plus',
              'ce',
              'ivd',
              'iso-27001',
              'md',
              'bsi',
              'bsiukas',
              'cqc'
            ]
          : this.type === 'payment'
          ? ['visa', 'mastercard', 'amex', 'apple-pay', 'google-pay', 'stripe']
          : this.type === 'supplement-info'
          ? ['vegan', 'additive-free', 'gluten-free', 'free-delivery']
          : []
      }
    },
    white: {
      type: Boolean,
      required: false
    },
    centre: {
      type: Boolean,
      required: false
    },
    gap: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      required: false
    },
    title: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      types: ['accreditation', 'payment', 'supplement-info']
    }
  },
  computed: {
    fileName() {
      return image =>
        this.type === 'accreditation' && this.white ? `${image}-white` : image
    },
    fileType() {
      return this.type === 'accreditation' ? 'png' : 'svg'
    },
    getImageLink() {
      return image =>
        this.type === 'accreditation' && image === 'cqc'
          ? 'https://www.cqc.org.uk/'
          : ''
    },
    filePath() {
      return image =>
        this.types.includes(this.type)
          ? require(`../../assets/images/icons/${this.type}/${this.fileName(
              image
            )}.${this.fileType}`)
          : image
    },
    imageAltText() {
      return image => image.split('/').pop().split('.')[0].replace(/-/g, ' ')
    },
    cssVars() {
      return {
        '--gap': `${this.gap}px`
      }
    }
  }
}
</script>

<template lang="pug">
.image-list-item
  h2(v-if='!!title') {{ title }}
  .image-list-item__content.flex-container.align-middle(
    :class='{ "align-center": centre, [`image-list-item__${type}`]: type, "sp__top--sm": !!title }'
    :style='cssVars'
  )
    div(v-for='image in images')
      a(v-if='getImageLink(image)' :href='getImageLink(image)')
        img(
          :src='filePath(image)'
          :alt='imageAltText(image)'
          :height='height'
          :key='image'
          :class='{ "image-list-item__image": type === "payment" && image !== "amex" }'
        )
      img(
        v-else
        :src='filePath(image)'
        :alt='imageAltText(image)'
        :height='height'
        :key='image'
        :class='{ "image-list-item__image": type === "payment" && image !== "amex" }'
      )
</template>

<style lang="stylus" scoped>
@import '../../assets/styles/modules/*'

.image-list-item
  &__content
    gap: var(--gap)
    flex-wrap: wrap
    justify-content: flex-start;
  &__image
    border: 1px solid THRIVA.colours.pebble
    border-radius: 3px
</style>
